
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningNoackIec as ObiWarningNoackIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-noack-iec.js';
 
 
 

 
 export const ObiWarningNoackIec = createComponent({
   react: React,
   tagName: 'obi-warning-noack-iec',
   elementClass: ObiWarningNoackIecElement,
   events: {
     
   }
  });
 
 